























import {
  BaseResultModel,
  EVENT_BUS,
  SalesPackTabConstants,
  SalesPackTabModel,
  StoreConstants,
  WorkflowJobButtonModel,
  WorkflowJobProcessResultModel,
  WorkflowJobTabModel,
  WorkflowStandardProcessingAction
} from '@/types';
import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import SalesPack from '@/components/workflow/automotive/tabs/shared/SalesPack.vue';
import { SalesPackService } from '@/services/automotive/SalesPackService';
import { Base64Utils } from '@/utils';
import { EventBus } from '@/classes/EventBus';
import { TabsHelper, AutomotiveSalesPackTab } from '@/mixins';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
  name: 'PreSalesPackTab',
  mixins: [TabsHelper, AutomotiveSalesPackTab],
  props: {
    isWorkflowJobLocked: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      preSalesPacks: [] as SalesPackTabModel[],
      isTabLoading: true,
      isPreviewing: false,
      isSending: false,
      salesPackRetrievalError: '',
      modalSpinnerPositioning: 'unset',
      authorizeWithOnFido: false
    };
  },
  methods: {
    ...mapActions('workflowJobStore', ['setPostProcessNavigation']),
    async getPreSalesPack(this: any) {
      try {
        this.preSalesPacks = await SalesPackService.getPreSalesPackAsync(this.workflowJobId);
      } catch (error) {
        this.$log(`Error getting ${this.tabDescription}.`);
        this.salesPackRetrievalError = (error as BaseResultModel).notification;
      } finally {
        this.isTabLoading = false;
        this.handleTabsLoaded();
      }
    },
    async previewPreSalesPack(this: any) {
      this.isPreviewing = true;
      const salesPacksToSendForPreview = (this.preSalesPacks as SalesPackTabModel[]).filter((x) => x.include);
      if (this.validateSalesPackDocuments(salesPacksToSendForPreview)) {
        const previewWindow = window.open();
        previewWindow?.document.write(SalesPackTabConstants.SalesPackGeneratingMarkup);
        try {
          const response = await SalesPackService.getPreSalesPackPreviewAsync(
            this.workflowJobId,
            salesPacksToSendForPreview.map((x) => x.documentTypeId)
          );
          Base64Utils.previewBase64(response, previewWindow);
        } catch (error) {
          this.$log(`Error getting ${this.tabDescription} preview.`);
          previewWindow?.close();
        } finally {
          this.isPreviewing = false;
        }
      } else {
        this.isPreviewing = false;
      }
    },
    async signPreSalesPack(this: any) {
      this.isSending = true;
      try {
        const salesPacksToSendForSigning = (this.preSalesPacks as SalesPackTabModel[]).filter((x) => x.include);
        if (this.validateSalesPackDocuments(salesPacksToSendForSigning)) {
          const processResult: WorkflowJobProcessResultModel = await SalesPackService.sendPreSalesPackForSigningAsync(
            this.workflowJobId,
            salesPacksToSendForSigning.map((x) => x.documentTypeId),
            this.authorizeWithOnFido
          );
          if (processResult?.postProcessNavigation) {
            this.setPostProcessNavigation({
              queueId: processResult.postProcessNavigation.queueId,
              jobId: processResult.postProcessNavigation?.jobId
            });
          }

          EventBus.$emit(EVENT_BUS.PROCESS_JOB, {
            processingAction: WorkflowStandardProcessingAction.ProcessJob
          } as WorkflowJobButtonModel);
        } else {
          this.isSending = false;
        }
      } catch (error) {
        this.$log(error);
        this.isSending = false;
      }
    },
    updatePreSalesPackItem(this: any, documentTypeId: number, checked: boolean) {
      const preSalesPackItemIndex = (this.preSalesPacks as SalesPackTabModel[]).findIndex((x) => x.documentTypeId === documentTypeId);
      if (preSalesPackItemIndex > -1) {
        Vue.set(this.preSalesPacks, preSalesPackItemIndex, {
          ...this.preSalesPacks[preSalesPackItemIndex],
          include: checked
        });
      }
    },
    updateOnfido(checked: boolean) {
      this.authorizeWithOnFido = checked;
    }
  },
  computed: {
    ...mapGetters(StoreConstants.WorkflowJob.ModuleName, [StoreConstants.WorkflowJob.Getters.VerticalJobTabs]),
    isSubmitting(this: any) {
      return this.isPreviewing || this.isSending;
    },
    tabDescription(this: any) {
      return (this[StoreConstants.WorkflowJob.Getters.VerticalJobTabs] as WorkflowJobTabModel[]).find((x) => x.componentName === this.$options.name)?.description || 'Sales Pack';
    }
  },
  async mounted(this: any) {
    await this.getPreSalesPack();
  },
  components: {
    LoadingSpinner,
    SalesPack
  },
  created(this: any) {
    this.workflowJobId = Number(this.$route.params.jobId);
  }
});
